<template>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {deleteCustomerSignatureAction} from '@/modules/common/api'
export default {
    name: "initVuex",
  created() {
    this.$store.dispatch('fetchTradingNames');
  },
}
</script>
<style scoped></style>

